/*
 * View for conversation variables
 */

define([
  "marionette",
  "modules/shared/conversationVariables/template/conversationVariablesTemplate.html",
], function (Marionette, ConversationVariablesTemplate) {
  var ConversationVariablesView = {};

  ConversationVariablesView.conversationVariablesLayout = Marionette.Layout.extend({
    template: ConversationVariablesTemplate,
    regions: {
      list: "#list",
    },
  });

  return ConversationVariablesView;
});
